import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import LegalDocument from '../LegalDocument/LegalDocument.tsx';

const DEFAULT_LANG = 'en';

const tosFilesByPath = import.meta.glob('../../legal/tos.*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const tosByLang: Record<string, string> = Object.entries(
  tosFilesByPath
).reduce<Record<string, string>>((acc, [path, content]) => {
  const match = path.match(/tos\.([a-z]+)\.md$/);
  if (match) {
    acc[match[1]] = content;
  }
  return acc;
}, {});

const resolveContent = (lang: string): string => {
  const short = (lang || DEFAULT_LANG).split('-')[0].toLowerCase();
  return tosByLang[short] ?? tosByLang[DEFAULT_LANG] ?? '';
};

const TermsOfUse: React.FC = () => {
  const { i18n } = useTranslation();
  const content = useMemo(
    () => resolveContent(i18n.language),
    [i18n.language]
  );

  return <LegalDocument content={content} />;
};

export default TermsOfUse;
